import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import $ from 'jquery';
import PropertySearchMapElements from './PropertySearchMapElements.js';
import 'swiper/css';
import 'swiper/css/navigation';

if (document.getElementById('propertySearchMap')) {
    const psp = document.getElementById('propertySearchMap');
    const pid = psp.attributes['data-page-id'].value;
    const heading = psp.attributes['data-page-heading']?.value;
    const intro = psp.attributes['data-page-intro']?.value;
    const cta = psp.attributes['data-page-cta']?.value;
    const btnLabel = psp.attributes['data-page-btn-label']?.value;
    const noResults = psp.attributes['data-page-no-results']?.value;

    const root = createRoot(psp);
    async function GetInitial() {
        const cfg = await fetch('/ppi/propertysearchapi/getsearchconfig?contentId=' + pid);
        const c = await cfg.json();

        if (window.location.href.indexOf('?')) {
            // Set initial form params if any on QS
            const p = new URLSearchParams(window.location.href.split('?')[1]);
            p.forEach((v, k) => {
                const vs = p.getAll(k); // May have multiple values of the same param
                if (vs.length > 1) {
                    c[k] = vs;
                } else {
                    c[k] = v;
                }
            });
        }

        root.render(
            <StrictMode>
                <PropertySearchMapElements pageId={pid} config={c} initialUrl={window.location.href} content={{heading:heading, intro:intro, cta:cta, btnLabel:btnLabel, noResults:noResults }} />
            </StrictMode>
        );
    }
    GetInitial();
}